import * as actions from '../actions/actionTypes';

const initialState = {
  balanceHours: [],
  currentBalance: 0,
  extraHours: [],
  bankHours: [],
  loading: false,
};

const fetchBankHoursSuccess = (state, action) => ({
  ...state,
  bankHours: action.bankHours,
});

const updateBankHourSuccess = (state, action) => ({
  ...state,
  currentBankHour: action.currentBalance,
});

const fetchBalanceHoursSuccess = (state, action) => ({
  ...state,
  balanceHours: action.balanceHours,
});

const updateBalanceHourSuccess = (state, action) => ({
  ...state,
  currentBalance: action.currentBalance,
});

const updateBalanceHourStart = state => ({
  ...state,
  loading: true,
});

const updateBalanceHourEnd = state => ({
  ...state,
  loading: false,
});

const fetchExtraHoursSuccess = (state, action) => ({
  ...state,
  extraHours: action.extraHours,
});

const createExtraHourSuccess = (state, action) => ({
  ...state,
  extraHours: state.extraHours.concat(action.extraHour),
  currentBalance: state.currentBalance - action.extraHour.amount,
});

const updateExtraHourSuccess = (state, action) => {
  let newBalance = state.currentBalance;
  const newExtraHours = state.extraHours.map((extraHour) => {
    if (extraHour.id === action.extraHour.id) {
      newBalance += extraHour.amount - action.extraHour.amount;
      return action.extraHour;
    }
    return extraHour;
  });

  return {
    ...state,
    extraHours: newExtraHours,
    currentBalance: newBalance,
  };
};

const deleteExtraHourSuccess = (state, action) => ({
  ...state,
  extraHours: state.extraHours.filter(extraHour => extraHour.id !== action.id),
  currentBalance: state.currentBalance + action.amount,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_BANK_HOURS_SUCCESS:
      return fetchBankHoursSuccess(state, action);
    case actions.UPDATE_BANK_HOUR_SUCCESS:
      return updateBankHourSuccess(state, action);
    case actions.FETCH_BALANCE_HOURS_SUCCESS:
      return fetchBalanceHoursSuccess(state, action);
    case actions.UPDATE_BALANCE_HOUR_SUCCESS:
      return updateBalanceHourSuccess(state, action);
    case actions.UPDATE_BALANCE_HOUR_START:
      return updateBalanceHourStart(state, action);
    case actions.UPDATE_BALANCE_HOUR_END:
      return updateBalanceHourEnd(state, action);

    case actions.FETCH_EXTRA_HOURS_SUCCESS:
      return fetchExtraHoursSuccess(state, action);
    case actions.CREATE_EXTRA_HOUR_SUCCESS:
      return createExtraHourSuccess(state, action);
    case actions.UPDATE_EXTRA_HOUR_SUCCESS:
      return updateExtraHourSuccess(state, action);
    case actions.DELETE_EXTRA_HOUR_SUCCESS:
      return deleteExtraHourSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
